export type TipoSistema = 1 | 2;

export type ListaItensSistema = {
  icone: string;
  name: string;
  value: number;
  manifest: string;
  nomeExibicao: string;
};

const TipoSistemaEnum = {
  ZENDAR: 0,
  POWERSTOCK: 1,
  STI3: 2,
  FOMER: 3,
  FOMER_SISTEMA: 4,

  properties: {
    1: {
      name: 'zendar',
      value: 0,
      nomeExibicao: 'Zendar Dashboard',
      manifest: `${process.env.PUBLIC_URL}/manifestZendar.json`,
    },
    2: {
      name: 'powerstock',
      value: 1,
      nomeExibicao: 'Powerstock Dashboard',
      manifest: `${process.env.PUBLIC_URL}/manifestPowerstock.json`,
    },
    3: {
      name: 'sti3',
      value: 2,
      nomeExibicao: 'Sti3 Dashboard',
      manifest: `${process.env.PUBLIC_URL}/manifest.json`,
    },
    4: {
      name: 'fomersistema',
      value: 3,
      nomeExibicao: 'Fomer Dashboard',
      manifest: `${process.env.PUBLIC_URL}/manifestFomer.json`,
    },
    5: {
      name: 'fomer',
      value: 4,
      nomeExibicao: 'Fomer Dashboard',
      manifest: `${process.env.PUBLIC_URL}/manifestFomer.json`,
    },
  },
};

export default TipoSistemaEnum;
